import ProgressLine from './component'

export default ProgressLine
